import React from 'react';
import YouTube from 'react-youtube';
import _ from 'lodash';
import {
	FaPlay,
	FaPause
} from 'react-icons/fa';
import {
	IoIosSkipBackward,
	IoIosSkipForward
} from "react-icons/io";
import {
	IframeContainer,
	PlayerControlContainer
} from './StyledComponents/StyleYoutubeIframe';

// BUFFERING: 3
// ​
// CUED: 5
// ​
// ENDED: 0
// ​
// PAUSED: 2
// ​
// PLAYING: 1
// ​
// UNSTARTED: -1
class YoutubeMultiPlay extends React.Component {
	constructor(props) {
		super(props);

		const { musicVideo } = props;
		const height = this.props.height ? this.props.height : 245;
		const width = this.props.width ? this.props.width : 320;

		this.state = {
			loadedPlayer:false,
			musicVideo,
			ytt: '',
			opts: {
				height,
				width,
				playerVars: { // https://developers.google.com/youtube/player_parameters
					autoplay: 0
				},
				loop: 1
			},
			playerState: -100
		}




		// console.log('reload youtube', musicVideo);
		// console.log('youtube states', YouTube.PlayerState );
	}

	componentDidUpdate(prevProps) {
		const {
			musicVideo,
			firstSongPlay
		} = this.props;
		const {
			loadedPlayer,
			ytt
		} = this.state;

		// console.log("MUSIC VIDEO", musicVideo);
		// if (!loadedPlayer){
		// 	return;
		// }

		if (prevProps.musicVideo !== musicVideo) {
			this.setState({ musicVideo });
		}
		if (prevProps.firstSongPlay !== firstSongPlay) {
			// this.setState({musicVideo});
			// console.log('her');
			ytt.target.playVideo();
		}

		//   console.log('prevProps.firstSongPlay', prevProps.firstSongPlay);
		//   console.log('first', firstSongPlay);
	}



	onPause = (event) => {

		this.setState((prevState) => ({
			...prevState,
			ytt: _.assign({}, event),
			playerState: event.target.getPlayerState()
		}));
		event.target.pauseVideo();


		// console.log('pause');
	};


	onStateChange = (event) => {
		const {
			setPlayerState
		} = this.props;
		const {
			loadedPlayer
		} = this.state;

		// console.log('loaded player', loadedPlayer);
		// console.log('state change');
		this.setState((prevState) => ({
			...prevState,
			ytt: _.assign({}, event),
			playerState: event.target.getPlayerState()
		}));

		const { playAutomatically } = this.props;
		const youtubePlayerState = event.target.getPlayerState();
		// console.log('evv', youtubePlayerState);
		if (playAutomatically && youtubePlayerState === 5) {
			// console.log('play true', event.target);
			event.target.playVideo();
		}
		setPlayerState(event.target.getPlayerState());
	};

	onReady = (event) => {
		const {
			setPlayerState
		} = this.props;
		// console.log('ready');
		this.setState((prevState) => ({
			...prevState,
			loadedPlayer:true,
			ytt: _.assign({}, event),
			playerState: event.target.getPlayerState()
		}));
		
		setPlayerState(event.target.getPlayerState());
		// console.log('youtube ready');
		// event.target.pauseVideo();
	};

	controlYT = () => {
		const { setSongListWordingChange } = this.props;


		const { ytt } = this.state;
		const youtubePlayerState = ytt.target.getPlayerState();

		if (youtubePlayerState === 1) {
			ytt.target.pauseVideo();
		}
		else if (youtubePlayerState === 2 || youtubePlayerState === 5) {
			ytt.target.playVideo();
			setSongListWordingChange();
		}
	};

	onEnd = (event) => {
		const { onSongEnd } = this.props;
		onSongEnd();

		// ytt = _.assign({}, event);
		// console.log('end', ytt);
	};

	skipBackward = () => {
		const { skipBackward } = this.props;
		skipBackward();
	}

	skipForward = () => {
		const { skipForward } = this.props;
		skipForward();
	}

	render() {
		const {
			musicVideo,
			opts,
			ytt,
			playerState
		} = this.state;

		const {
			songSelected
		} = this.props;
		const {
			artist,
			name: songName,
			genre: songGenre,
			countrySelected
		} = songSelected;
		// console.log('songSelected', songSelected);
		// console.log('state player st', playerState);
		if (ytt !== '') {
			// const youtubePlayerState = ytt.target.getPlayerState();

			// console.log('youtubePlayerState', youtubePlayerState);
		}

		return (

			<>
				<IframeContainer
					className='ref-youtube-container-inner'
				>
					<YouTube
						title={musicVideo}
						opts={opts}
						videoId={musicVideo}
						onEnd={this.onEnd}
						onPause={this.onPause}
						onReady={this.onReady}
						onStateChange={this.onStateChange}
					/>
				</IframeContainer>
				<div
					className='ref-song-info'
					style={{
						textAlign: 'center'
					}}
				>
					<h5>{songName} - {artist}</h5>
					<h6>{songGenre} - {countrySelected}</h6>
				</div>

				<PlayerControlContainer>
					<div
						onClick={this.skipBackward}
					>
						<IoIosSkipBackward
							size={40}
						/>
					</div>
					<div onClick={this.controlYT}>
						{
							playerState === -100 ||
								playerState === 2 ||
								playerState === 5 ?
								<FaPlay
									size={40}
								/>
								:
								<FaPause
									size={40}
								/>
						}

					</div>
					<div
						onClick={this.skipForward}
					>
						<IoIosSkipForward
							size={40}
						/>
					</div>
				</PlayerControlContainer>
			</>
		);
	}


};

export default YoutubeMultiPlay;
